import { combineReducers, Reducer } from 'redux';

import workItems from './waivers/workItems/waiverWorkItemsReducer';
import workItemDetails from './waivers/workItems/waiverWorkItemDetailsReducer';
import workItemResolutions from './waivers/workItems/waiverWorkItemResolutionsReducer';
import airlines from './waivers/airlines/waiverAirlinesReducer';
import waivers from './waivers/waivers/waiversReducer';
import configurations from './waivers/waiverConfigurations/waiverConfigurationsReducer';

import { EntityState, Action } from '../types';

const rootReducer: Reducer<EntityState['waivers'], Action<any>> = combineReducers({
  workItems,
  workItemDetails,
  workItemResolutions,
  airlines,
  waivers,
  configurations,
});

export default rootReducer;
